<template>
    <div class="risk-facts">
        <b-carousel
            class="risk-facts-carousel"
            indicators
            :interval="0"
            v-model="slide"
            ref="carousel"
        >
            <b-carousel-slide>
                <b-card
                    class="risk-facts-carousel-card"
                    img-top
                    img-alt="The Shield family"
                    :img-src="require('@assets/images/risk-slideshow-1.png')"
                >
                    <b-row align-h="center">
                        <b-col cols="10">
                            <h2 class="text-center mb-3">
                                Fact 1:
                                <span class="font-weight-normal">Disclosure forms are legal documents</span>
                            </h2>
                        </b-col>
                    </b-row>

                    <b-row align-h="center">
                        <b-col
                            cols="12"
                            md="8"
                        >
                            <b-row align-v="center">
                                <b-col
                                    cols="4"
                                    md="2"
                                >
                                    <b-img
                                        fluid
                                        alt="Mr. Shield"
                                        :src="require('@assets/images/smarty-says-mr.png')"
                                    />
                                </b-col>

                                <b-col
                                    cols="8"
                                    md="10"
                                >
                                    <div class="font-italic text-left">
                                        <div>
                                            <strong>Don't worry</strong>, our disclosure process is designed by legal
                                            experts.
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>
            </b-carousel-slide>

            <b-carousel-slide>
                <b-card
                    class="risk-facts-carousel-card"
                    img-top
                    img-alt="The Shield family"
                    :img-src="require('@assets/images/risk-slideshow-2.png')"
                >
                    <b-row align-h="center">
                        <b-col cols="10">
                            <h2 class="text-center mb-3">
                                Fact 2:
                                <span class="font-weight-normal">
                                    Mistakes disclosing the condition of the home are the #1 cause of home-sale lawsuits
                                </span>
                            </h2>
                        </b-col>
                    </b-row>

                    <b-row align-h="center">
                        <b-col
                            cols="12"
                            md="8"
                        >
                            <b-row align-v="center">
                                <b-col
                                    cols="4"
                                    md="2"
                                >
                                    <b-img
                                        fluid
                                        alt="Mr. Shield"
                                        :src="require('@assets/images/smarty-says-mrs.png')"
                                    />
                                </b-col>

                                <b-col
                                    cols="8"
                                    md="10"
                                >
                                    <div class="font-italic text-left">
                                        <div>
                                            <strong>Don't fret</strong>, we provide tips and resources to help prevent
                                            mistakes.
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>
            </b-carousel-slide>

            <b-carousel-slide>
                <b-card
                    class="risk-facts-carousel-card"
                    img-top
                    img-alt="The Shield family"
                    :img-src="require('@assets/images/risk-slideshow-3.png')"
                >
                    <b-row align-h="center">
                        <b-col cols="10">
                            <h2 class="text-center mb-3">
                                Fact 3:
                                <span class="font-weight-normal">
                                    Even with accurate disclosure, there is still risk after the sale
                                </span>
                            </h2>
                        </b-col>
                    </b-row>

                    <b-row align-h="center">
                        <b-col
                            cols="12"
                            md="8"
                        >
                            <b-row align-v="center">
                                <b-col
                                    cols="4"
                                    md="2"
                                >
                                    <b-img
                                        fluid
                                        alt="Mr. Shield"
                                        :src="require('@assets/images/smarty-says-offspring-1.png')"
                                    />
                                </b-col>

                                <b-col
                                    cols="8"
                                    md="10"
                                >
                                    <div class="font-italic text-left">
                                        <div class="mb-1">
                                            Common home problems, such as a roof leak, can trigger a buyer legal claim
                                            well after the sale, regardless of fault.
                                        </div>

                                        <div v-if="notProtected">
                                            Don't worry, you can walk away safe by opting into our Home Sale Legal
                                            Protection™, details to follow.
                                        </div>

                                        <div v-else>
                                            Don't worry,
                                            <span v-if="payAtClose">
                                                <span v-if="purchasedByAgent">
                                                    your agent has reserved Home Sale Legal Protection™ for you
                                                </span>

                                                <span v-else>
                                                    you've reserved Home Sale Legal Protection™
                                                </span>
                                            </span>

                                            <span v-else>
                                                <span v-if="purchasedByAgent">
                                                    your agent has purchased Home Sale Legal Protection™ for you
                                                </span>

                                                <span v-else>
                                                    you've got Home Sale Legal Protection™
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>
            </b-carousel-slide>
        </b-carousel>

        <b-row align-h="center">
            <b-col
                cols="6"
                md="4"
                class="text-center"
            >
                <b-form-checkbox
                    class="justify-content-center mb-4"
                    name="terms"
                    inline
                    v-if="!orderAppResource.eulaAcceptedAt && this.isLastStep"
                    v-model="status"
                    value="accepted"
                    unchecked-value="notAccepted"
                >
                    I understand the risks and responsibilities that come with disclosing information for my home sale.
                </b-form-checkbox>
                <b-button
                    class="gold-button"
                    size="lg"
                    block
                    v-if="isContinueButton"
                    @click="handleClick"
                >
                    Continue
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import './RiskFacts.scss';
import {isProtected, notProtected, payAtClose, purchasedByAgent} from '@helpers/order';

export default {
    name: 'RiskFacts',
    data: () => ({
        slidesLength: 3,
        slide: 0,
        status: 'notAccepted',
    }),
    props: {
        orderAppResource: {
            type: Object,
        },
    },
    computed: {
        isContinueButton() {
            if (this.orderAppResource.eulaAcceptedAt) {
                return true;
            } else {
                return (this.status === 'notAccepted' && !this.isLastStep) ||
                    this.status === 'accepted';
            }
        },
        isLastStep() {
            return this.slide === this.slidesLength - 1;
        },
        notProtected() {
            return notProtected(this.orderAppResource);
        },
        payAtClose() {
            return payAtClose(this.orderAppResource);
        },
        isProtected() {
            return isProtected(this.orderAppResource);
        },
        purchasedByAgent() {
            return purchasedByAgent(this.orderAppResource);
        },
    },
    methods: {
        handleClick() {
            if (!this.isLastStep) {
                this.$refs.carousel.next();
            } else {
                this.$emit('submit');
            }
        },
    },
}
</script>
